export const SMEERLOZE_CONSTRUCTIES_CROSSELLING = [
    [0, "128671", "Gereedschapkoffer DeltaSwitch"],
    [1, "128661", "Onderdelenset,v montage DeltaSwitch"]
];
export const SMEERLOZE_CONSTRUCTIES = [
    [0, "128501", "DeltaSwitch, hoog tongprofiel", [0, 1]]
];
export const parse = (row) => {
    const [_key, _art, _description, _crosssell] = row;
    const parsed = {
        key: _key,
        artCodeTSNL: _art,
        aantal: 1,
        category: "smeerlozeConstructies",
        crosssell: _crosssell.map(i => SMEERLOZE_CONSTRUCTIES_CROSSELLING[i][1]),
        _description,
        description() { return description(parsed); },
    };
    return parsed;
};
export const description = (row) => {
    // ${getTextFixed("smeerlozeConstructie")}
    return `${row._description} (${row.artCodeTSNL})`;
};
